<template>
  <b-modal
    :hide-footer="true"
    centered
    size="lg"
    id="atendimento-edicao-modal"
    @hidden="$bvModal.hide('atendimento-edicao-modal')"
  >
    <template #modal-title>
      <strong class="font-size-19">
        Atendimento
      </strong>
    </template>
    <form @submit.prevent="putAtendimento">
      <section class="row">
        <form-input
          :required="true"
          grid="12"
          label="Descrição do atendimento"
          v-model="atendimento.descricao_sumaria"
        />

        <div class="col-6 d-flex align-items-center">
          <div class="float-left mr-2">
            <toggle-button
              :sync="true"
              color="#5685D8"
              id="interprete"
              name="interprete"
              v-model="atendimento.necessita_interprete_libras"
            />
          </div>
          Necessita de intérprete de Libras?
        </div>

        <form-calendar
          :required="true"
          grid="6"
          label="Data da solicitação"
          id="dataSolicitacao"
          name="dataSolicitacao"
          :max-date="date_now"
          v-model="atendimento.data_cadastro"
        />

        <form-select
          :required="true"
          grid="12"
          label="Formas de acesso"
          id="formasAcesso"
          name="formasAcesso"
          :loading="loadingOptions"
          v-model="atendimento.forma_acesso_id"
          :itens="agendamentosStore?.state?.formas_acesso"
        />

        <form-select
          :required="true"
          grid="12"
          label="Onde será atendido"
          id="local"
          name="local"
          :loading="loadingOptions"
          v-model="atendimento.local"
          :itens="agendamentosStore?.state?.locais_atendimento"
          @selected="setLocal"
        />

        <form-select
          grid="12"
          label="Unidades internas"
          id="unidadesInternas"
          name="unidadesInternas"
          :loading="loadingOptions"
          v-model="atendimento.outra_unidade"
          v-if="agendamentosStore?.state?.local_atendimento?.permite_outra_unidade"
          :itens="agendamentosStore?.state?.unidades_internas"
        />

        <form-select
          grid="12"
          label="Serviço SOCIOASSISTENCIAL"
          id="servico"
          name="servico"
          :loading="loadingOptions"
          v-model="atendimento.tipo_servico_id"
          :itens="agendamentosStore?.state?.servicos"
        />

        <form-select
          :multiple="true"
          :required="true"
          label="Tipo de atendimento solicitado"
          id="tipoAtendimentoSolicitado"
          name="tipoAtendimentoSolicitado"
          grid="12"
          :loading="loadingOptions"
          v-model="atendimento.tipos"
          :itens="agendamentosStore?.state?.tipos"
        />
      </section>
      <section class="d-flex flex-row justify-content-end mt-3" style="column-gap: 5px">
        <button
          class="btn btn-submit-atendimento-edicao btn-success mr-0"
          data-style="zoom-in"
          type="submit"
        >
              {{ $t("Atualizar") }}
          <i
            class="mdi mdi-check"
          />
        </button>
      </section>
    </form>
  </b-modal>
</template>

<script>
export default {
  name: "AtendimentoModal",
  props: [
    "atendimento",
    "loadingOptions",
    "agendamentosStore",
    "putAtendimento"
  ],
  data() {
    return {
      date_now: moment().format("YYYY/MM/DD"),
    }
  },
  methods: {
    setLocal(localId) {
      if (localId) {
        const local_atendimento = this.agendamentosStore?.state?.locais_atendimento.find((e) => e.id === localId);

        this.agendamentosStore?.commit("SET_LOCAL_ATENDIMENTO", local_atendimento);
      }
    },
  }
}
</script>
